import { SIDENAV_GROUP_BY, TIER } from "@/constants";
import { isEmbedded } from "@/remote/contract";

export const NEW = "NEW";
export const COMING_SOON = "COMING_SOON";

export type SideNavItemStatus = typeof NEW | typeof COMING_SOON;

export type SideNavPill = {
  variant: "info" | "warning" | "danger" | "success";
  text: string;
};

export const sideNavSectionLabelByGroup = (
  group: string,
  tier: string,
): string => {
  // Embedded (Cyber Security host) uses the new-platform section naming: the
  // products group reads "Products" and the management group (license usage)
  // gains a "Management" header it does not carry standalone.
  const embedded = isEmbedded();
  if (group === SIDENAV_GROUP_BY.BETA && tier !== TIER.system) {
    return embedded ? "products" : "solutions";
  }
  if (embedded && group === SIDENAV_GROUP_BY.GAMMA && tier !== TIER.system) {
    return "management";
  }
  if (group === SIDENAV_GROUP_BY.NIU && tier !== TIER.system) {
    return "partners";
  }
  return "";
};
